export const DESKTOP_DOWNLOAD_URL = 'https://nimbalyst.com/download';

/**
 * Build the desktop handoff link for an accepted team invitation.
 *
 * The link deliberately carries no Stytch token. The desktop app joins a team by
 * exchanging a session it already holds, so the only thing this has to transport
 * is which org to join and which address was invited — and the app's auth
 * deep-link handler can keep rejecting unsolicited credential-bearing links.
 */
export function desktopInviteHandoffUrl(orgId: string, email?: string): string {
  const url = new URL(`nimbalyst://invite/${encodeURIComponent(orgId)}`);
  if (email) url.searchParams.set('email', email);
  return url.toString();
}

/**
 * The same request, addressed to someone who has the app.
 *
 * Two schemes for one resource, deliberately: the https console link works for
 * anybody, and this one is only an offer. Answering in the browser is the
 * supported path, not a downgrade of it.
 */
export function desktopFeedbackRequestUrl(orgId: string, requestId: string): string {
  const url = new URL(`nimbalyst://feedback-request/${encodeURIComponent(requestId)}`);
  url.searchParams.set('orgId', orgId);
  return url.toString();
}
